<kendo-loader *ngIf="loadSpinner && showLoadingSpinner" size="large" type="converging-spinner" class="load-spinner"></kendo-loader>
<div class="card-section header-styles" *ngIf="studentDetails">
  <div class="example-configs" [ngClass]="{
      'bg-orange': studentData?.caseStage === 'Reevaluation',
      'bg-green': studentData?.caseStage === 'Annual',
      'bg-blue': studentData?.caseStage === 'Initial',
      'bg-gray': studentData?.caseStage === 'Triennial',
      'bg-lightGray': studentData?.caseStage === 'Active'
    }">
    <!---TODO: Revisit this with @Vadim for below role="img"---->
    <div class="top">
      <p class="!k-font-semibold">{{ studentData?.caseStage }}</p>
      <div class="icons-group" kendoTooltip position="bottom">
        <kendo-avatar size="small" rounded="none" role="img" [svgIcon]="hand"
          class="iconsList hand {{ studentData?.referralColor }}" fillMode="none" title="Referrals"></kendo-avatar>
        <kendo-avatar size="small" rounded="none" role="img" class="iconsList {{ studentData?.evalColor }}"
          [svgIcon]="magnifyingGlass" fillMode="none" title="Evaluations"></kendo-avatar>
        <kendo-avatar size="small" rounded="none" role="img" [svgIcon]="fileSignature"
          class="iconsList {{ studentData?.iepColor }}" fillMode="none" title="IEP"></kendo-avatar>
        <kendo-avatar size="small" rounded="none" role="img" [svgIcon]="graduationCap"
          class="iconsList {{ studentData?.placementColor }} graduationCap" fillMode="none"
          title="Placement"></kendo-avatar>
      </div>
    </div>
  </div>

  <div class="example-config" [class.bg-error]="rfd">
    <div class="student-info-container">
      <div class="col">
        <div class="student-name-container">
          <h4 class="margin-0 primary-color font-18">
            {{ studentData?.lastName }}, {{ studentData?.firstName }}
          </h4>
        </div>
        <!-- Rfd Required -->
        <div *ngIf="rfd" class="rfd-container">
          <fa-icon [icon]="faTriangleExclamation" class="fa-xs"></fa-icon>
          <span class="small-text-semibold k-ml-1px">Reason for Delay Needed</span>
        </div>
        <p class="secondary-color">
          Student ID:
          {{ studentData?.nycid }}
          | DOB:
          {{ studentData?.dob | date : "MM/dd/yyyy" }}
        </p>
        <p class="secondary-color">
          DBN: {{ studentData?.dbn }} | {{ studentData?.district }}
        </p>
      </div>
      <div class="col">
        <p class="label secondary-color font-12">Assigned To</p>
        <div *ngIf="
            studentData?.assigned &&
            studentData?.caseAssdFirstName &&
            studentData?.caseAssdLastName
          ">
          <p>
            {{
            studentData?.caseAssdFirstName +
            " " +
            studentData?.caseAssdLastName
            }}
            <button class="!k-p-0" [svgIcon]="addressBook" fillMode="flat" kendoButton kendoPopoverAnchor
              title="Contact" #popoverAnchor="kendoPopoverAnchor" (click)="popoverAnchor.show()"
              [popover]="addressPopover" size="medium"></button>
          </p>

          <kendo-popover #addressPopover>
            <ng-template kendoPopoverBodyTemplate>
              <div class="!k-d-flex k-justify-content-between k-align-items-end">
                <p style="font-weight: 600" class="!k-my-0">
                  {{
                  studentData?.caseAssdFirstName +
                  " " +
                  studentData?.caseAssdLastName
                  }}
                </p>

                <button kendoButton fillMode="flat" [svgIcon]="xIcon" size="small" (click)="popoverAnchor.hide()"
                  title="Close"></button>
              </div>
              <p class="!k-mt-0 !k-mb-3">
                {{ studentData?.caseAssdEmail }}
                <button class="!k-p-0" [svgIcon]="copy" fillMode="flat" kendoButton size="medium"
                  (click)="copyClipboard(studentData?.caseAssdEmail)" title="Copy"></button>
              </p>
            </ng-template>
          </kendo-popover>
        </div>
        <div *ngIf="!studentData?.assigned" class="!k-mt-1">
          <span class="k-font-semibold k-text-error">Unassigned</span>
          <button kendoButton *ngIf="user?.isGlobalUser" tabindex="0"
            class="!k-p-0 k-text-primary k-cursor-pointer assign-btn" fillMode="link"
            (click)="showReAssign$.next(true)">(Assign)</button>
        </div>
      </div>
      <div class="col">
        <p class="label secondary-color font-12">Evaluation Site</p>
        <p>{{ studentData?.evaluationSite }}</p>
      </div>

      <div class="activity-col">
        <p class="label secondary-color font-12">Activity</p>
        <b>{{ studentData?.caseStage }}: </b><p class="previous-activity"><ng-container *ngFor="let activityPart of formatPreviousActivity(studentData?.activity); let first = first"><br *ngIf="!first" />{{ activityPart }}</ng-container></p>
    <span *ngIf="studentData?.prevActivity"><b>{{ getActivityLabel(studentData?.caseStage) }}: </b><p class="previous-activity"><ng-container *ngFor="let activityPart of formatPreviousActivity(studentData?.prevActivity); let first = first"><br *ngIf="!first" />{{ activityPart }}</ng-container></p></span>
    
      </div>
      <div class="date-cols">
        <p class="label secondary-color font-12">Activity Due Date</p>
        <ng-container *ngIf="dueDatesArray?.length">
          <ng-container *ngFor="let obj of dueDatesArray">
            <b><span data-qa="compliance-date-type">
            {{ getReferralType(obj?.referraltype) }}:
          </span></b>
            <p class="font-14" [class.at-risk]="studentData.complianceStatus === 'At Risk'" [class.k-text-error]="
                studentData.complianceStatus === 'Out of Compliance'">
              <fa-icon *ngIf="studentData.complianceStatus === 'At Risk'" [icon]="circleExclamation"
                title="At Risk"></fa-icon>
              <fa-icon *ngIf="studentData.complianceStatus === 'Out of Compliance'" icon="triangle-exclamation"
                title="Out of compliance"></fa-icon>
              <fa-icon *ngIf="studentData.complianceStatus === 'Reason for Delay'" icon="business-time"
                title="Reason for Delay"></fa-icon>
              {{ obj?.descr }}: {{ obj?.date }}<br />
              ({{ obj?.days }} {{ getDayLabel(obj?.days) }})
            </p>
          </ng-container>
        </ng-container>
      </div>
      <div class="date-cols">
        <p class="label secondary-color font-12">Compliance Date</p>
        <ng-container *ngIf="complianceDatesArray?.length">
          <ng-container *ngFor="let obj of complianceDatesArray">
            <b><span data-qa="compliance-date-type">
            {{ getReferralType(obj?.referraltype) }}:
          </span></b>
        <p class="font-14" [class.k-text-error]="obj?.days?.startsWith('-')">
              <fa-icon *ngIf="obj?.days?.startsWith('-')" icon="triangle-exclamation"></fa-icon>
              {{ obj?.descr }}: {{ obj?.date }}<br />
              ({{ obj?.days }} {{ getComplianceDayLabel(obj?.days) }})
            </p>
          </ng-container>
        </ng-container>
      </div>
      <div class="actions-col" *ngIf="showAction && isStudentSKValid()">
        <button kendoButton #anchor [themeColor]="'primary'" fillMode="solid" (click)="loadActions($event)">
          <kendo-loader *ngIf="loading.actions" size="small"> </kendo-loader>
          Actions
          <kendo-contextmenu [target]="anchor" size="large" showOn="click">
            <ng-template kendoContextMenuTemplate>
              <app-custom-actions [actionsList]="actionsList" [studentDetails]="studentData"
                (scheduleMeetingDialog)="showScheduleMeetingDialog$.next($event)"
                (cancelMeetingDialog)="showCancelMeetingDialog$.next($event)"
                (closeRequestForReevaluationDialog)="showCloseRequestForReevaluationDialog$.next($event)"
                (caseClosingEventsDialog)="showCaseClosingEventsDialog$.next($event)"
                (captureFirstAttendDate)="showCaptureFirstAttendDate$.next($event)"
                (reAssign)="showReAssign$.next($event)" (uploadDialog)="showUpload$.next($event)"
                (amendIEPDialog)="openAmendDialog($event)" (annualIEPDialog)="openAnnualDialog($event)"
                (removeFromMDEWorklistDialog)="openRemoveMDEWorklistDialog($event)"
                (meetingType)="meetingType = $event" (meetingSk)="meetingSk = $event" (isViewMode)="isViewMode = $event"
                (actionText)="actionText = $event" (meetingRoster)="meetingRoster = $event" (pwn)="pwn = $event"
                (isReAssign)="isReAssign = $event" (rfdDialog)="displayRfdDialog($event)"
                (createIepLoading)="isCreatingIep = $event">
              </app-custom-actions>
            </ng-template>
          </kendo-contextmenu>
        </button>
        <div #container></div>
      </div>
    </div>
  </div>
</div>

<kendo-dialog *ngIf="showRfdDialog$ | async" [title]="canEdit ? 'Add Reason for Delay' : 'View Reason for Delay'"
  (close)="rfd.onCloseClick()" [width]="786" [height]="'90vh'" [minWidth]="'1166'" (click)="$event.stopPropagation()">
  <app-reason-for-delay #rfd [studentDetails]="studentDetails" [referralsk]="referralSk"
    [studentSk]="studentDetails?.studentSk" [nycId]="studentDetails?.nycId" [eiId]="studentDetails?.eiId"
    [isPreSchool]="studentDetails?.isPreSchool" (close)="displayRfdDialog($event)" (saveEmitter)="onRfdSaved()"
    [canEdit]="canEdit">
  </app-reason-for-delay>
  <kendo-dialog-actions>
    <button kendoButton [fillMode]="'solid'" [themeColor]="'primary'" *ngIf="canEdit"
      [disabled]="!rfd.hasActiveReasons || rfd.loadSpinner" (click)="rfd.save()">Save</button>
  </kendo-dialog-actions>
</kendo-dialog>

<app-reassign-dialog *ngIf="showReAssign$ | async" (close)="showReAssign$.next(false)"
  [studentSk]="studentDetails?.studentSk" [nycId]="nycId" [isReAssign]="isReAssign">
</app-reassign-dialog>

<app-capture-first-attend-date-dialog [nycId]="nycId" *ngIf="showCaptureFirstAttendDate$ | async"
  (close)="showCaptureFirstAttendDate$.next(false)">
</app-capture-first-attend-date-dialog>




<app-document-upload *ngIf="showUpload$ | async" (close)="showUpload$.next(false)" [studentDetails]="studentDetails"
  [referralSk]="referralSk" [nycId]="nycId"></app-document-upload>

<kendo-dialog *ngIf="showCloseRequestForReevaluationDialog$ | async"
  (close)="showCloseRequestForReevaluationDialog$.next(false)" class="shm-window" [maxWidth]="1900" [width]="700"
  [minHeight]="300" [animation]="{ duration: 300, type: 'fade', direction: 'down' }" [themeColor]="'primary'">
  <app-close-request-for-reevaluation [referralSk]="referralSk" [iepType]="pwn"
    (close)="showCloseRequestForReevaluationDialog$.next(false)">
  </app-close-request-for-reevaluation>
</kendo-dialog>

<kendo-dialog *ngIf="showCancelMeetingDialog$ | async" (close)="showCancelMeetingDialog$.next(false)" class="shm-window"
  (keydown.enter)="$event.stopPropagation()" (click)="$event.stopPropagation()" [maxWidth]="1900" [width]="1400"
  [minHeight]="300" [animation]="{ duration: 300, type: 'fade', direction: 'down' }" [themeColor]="'primary'">
  <app-cancel-meeting [studentSk]="studentSk" (close)="showCancelMeetingDialog$.next(false)">
  </app-cancel-meeting>
</kendo-dialog>

<app-schedule-meeting [nycIds]="nycId" *ngIf="showScheduleMeetingDialog$ | async"
  (closeEmitter)="showScheduleMeetingDialog$.next(false)" [meetingType]="meetingType" [referralSk]="referralSk"
  [meetingSk]="meetingSk" [viewMode]="isViewMode" [regComplianceDate]="studentData?.complianceDate"
  [caseStage]="studentDetails?.caseStage" [meetingRoster]="meetingRoster" [actionText]="actionText">
</app-schedule-meeting>

<kendo-dialog title="Case Closing" *ngIf="showCaseClosingEventsDialog$ | async"
  (close)="showCaseClosingEventsDialog$.next(false)" [maxWidth]="1900" [width]="786" [maxHeight]="'90vh'"
  [minHeight]="300" [animation]="{ duration: 300, type: 'fade', direction: 'down' }">
  <app-case-closing [studentSk]="studentDetails?.studentSk" [complianceStatus]="studentData?.complianceStatus"
    [referralSk]="referralSk" (close)="showCaseClosingEventsDialog$.next(false)" [stdentDetails]="studentDetails"
    [eiId]="studentDetails?.eiId">
  </app-case-closing>
</kendo-dialog>


<kendo-dialog *ngIf="showAmendDialog$ | async" [width]="550" [height]="250" [minWidth]="350"
  (close)="onAmendDialogClose($event)" title="Are you sure">
  <p>This action will create an IEP Amendment, do you want to proceed?</p>

  <kendo-dialog-actions>
    <button kendoButton (click)="onAmendDialogClose({ text: 'No' })">No</button>
    <button kendoButton themeColor="primary" (click)="onAmendDialogClose({ text: 'Yes' })">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="showAnnualDialog$ | async" [width]="550" [height]="250" [minWidth]="350"
  (close)="onAnnualDialogClose($event)" title="Are you sure">

  <p>This action will create a new Annual Review IEP, do you want to proceed?</p>

  <kendo-dialog-actions>
    <button kendoButton (click)="onAnnualDialogClose({ text: 'No' })">No</button>
    <button kendoButton themeColor="primary" (click)="onAnnualDialogClose({ text: 'Yes' })">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="showRemoveMDEDialog$ | async" [width]="550" [height]="250" [minWidth]="350"
  (close)="onRemoveMDEWorklistDialogClose($event)" title="Please Confirm">

  <p>If you proceed, the student's record will be removed from this evaluation site. Are you sure to proceed?</p>

  <kendo-dialog-actions>
    <button kendoButton (click)="onRemoveMDEWorklistDialogClose({ text: 'No' })">No</button>
    <button kendoButton themeColor="primary" (click)="onRemoveMDEWorklistDialogClose({ text: 'Yes' })">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>

<div *ngIf="isCreatingIep" class="create-iep-navigation-overlay" role="status"
  aria-label="Creating IEP and opening the IEP page">
  <kendo-loader type="converging-spinner" size="large"></kendo-loader>
</div>